import { useMutation } from 'react-query';
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";

export const useMe = () => {
    const setUser = useAuthStore((state) => state.setUser);
    const clearAuth = useAuthStore((state) => state.clearAuth);

    return useMutation(PartnerApi.me, {
        onSuccess: (data) => {
            // Uložení uživatelských dat do Zustand store
            setUser(data);
        },
        onError: (error) => {
            clearAuth();
        },
    });
};